import _asyncToGenerator from "/var/jenkins_home/workspace/tingle.caa77636-11e8-4573-9fa8-b0d26a83c900/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.caa77636-11e8-4573-9fa8-b0d26a83c900/workspace/node_modules/next/node_modules/@babel/runtime/regenerator";
// ignore-string-externalization
import { createLoader } from '@spotify-internal/creator-data-loading';
import { fetchEntry, fetchEntryList } from '../Contentful';
export var templateLoader = createLoader( /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var contentType, urlSlug, smartlingLanguage, _ref$preview, preview;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            contentType = _ref.contentType, urlSlug = _ref.urlSlug, smartlingLanguage = _ref.smartlingLanguage, _ref$preview = _ref.preview, preview = _ref$preview === void 0 ? false : _ref$preview;
            _context.next = 3;
            return fetchEntry({
              contentType: contentType,
              filters: {
                urlSlug: urlSlug
              },
              locale: smartlingLanguage,
              preview: preview
            });

          case 3:
            return _context.abrupt("return", _context.sent);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}(), {
  cache: false
});
export var templateUrlsLoader = createLoader( /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var contentType, _ref3$preview, preview, resp;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            contentType = _ref3.contentType, _ref3$preview = _ref3.preview, preview = _ref3$preview === void 0 ? false : _ref3$preview;
            _context2.next = 3;
            return fetchEntryList({
              contentType: contentType,
              limit: 1000,
              select: ['fields.urlSlug'],
              preview: preview
            });

          case 3:
            resp = _context2.sent;
            return _context2.abrupt("return", resp.entries.map(function (e) {
              return e.urlSlug;
            }).filter(Boolean));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x2) {
    return _ref4.apply(this, arguments);
  };
}(), {
  cache: false
});